import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import Loader from '../../components/Loader'

const Notifications = () => {
    const [notifications, setNotifications] = useState([])
    const [hasMore, setHasMore] = useState(true)
    const [page, setPage] = useState(1)
    const [isLoading, setIsLoading] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        const getNotifications = async () => {
            try {
                setIsLoading(true)
                const response = await api.get("/notifications/")
                if (response) {
                    setIsLoading(false)
                    setNotifications(response?.data.notifications)
                    setHasMore(response.data.hasMore)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response?.data.message)
            }
        }

        getNotifications()
    }, [page])

    return (
        <div className='page'>
            <div className="page-body">
                <div className="notif-container">
                    <h4 className='page-title'>notifications</h4>
                    <InfiniteScroll
                        dataLength={notifications.length}
                        hasMore={hasMore}
                        next={(page) => setPage(page++)}
                    >
                        {notifications.map((notif) => (
                            <>
                                <div
                                    key={notif._id}
                                    className={`notification-card ${notif.read ? "read" : "unread"}`}
                                    onClick={() => navigate(`/${notif.org.name}`)}
                                    >
                                    <p className='label'>{notif.label}</p>
                                    {/* <div className="notification-indicator" /> */}

                                    <div className="notification-content">
                                        <p className="notification-message">
                                            {notif.message}
                                        </p>

                                        <div className="notification-meta">
                                            {/* <span className="notification-type">
                                            {notif.type === "orgPost" ? "Organization Update" : notif.type}
                                        </span> */}

                                            <span className="notification-time">
                                                {new Date(notif.createdAt).toLocaleString()}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}

                        {isLoading && <Loader />}

                    </InfiniteScroll>
                </div>
            </div>
        </div>
    )
}

export default Notifications